import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { PropertiesService } from "@scaffold/services/properties.service";
import { DataModelService } from "@services/data-model.service";

@Component({
  selector: "app-key-select",
  templateUrl: "./key-select.component.html",
  styleUrls: ["./key-select.component.scss"],
})
export class KeySelectComponent implements OnInit {
  @Input() selectedItem;
  @Input() rootItem;
  @Input() item: any;
  @Input() parentView: any;
  @Input() fileSet: boolean;
  @Output() changed = new EventEmitter();
  public selectedKey = "";
  public options = [];
  constructor(
    private dataModelService: DataModelService,
    public properties: PropertiesService
  ) {}

  ngOnInit(): void {
    this.selectedKey = this.selectedItem?.[this?.item?.param];
    this.dataModelService
      .getKeys(this.selectedItem?.list_view)
      .subscribe((keys) => {
        if (Array.isArray(keys)) {
          this.options = [...keys];
        }
      });
  }
  updateValue(){
    this.selectedItem[this.item.param] = this.selectedKey
    this.properties.changeValue();
    this.changed.emit(""); 
  }
}
